import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/Regions/ResultsData";

const updateResultsData: Reducer<ResultsData> = (state: ResultsData = new ResultsData(), action: Action<ActionType, ResultsData>) => {
  switch (action.type) {
    case ActionType.REGIONS_DATA_FETCHED:
      let fetchedItems = action.data.businessData,
        showMore = false
      if (action.data.totalRecords > fetchedItems.length) {
        showMore = true;
      }
      return { ...state, items: fetchedItems, showMore, total: action.data.totalRecords };
    default:
      return state;
  }
};

export default updateResultsData;